import { useQuery } from 'hooks/useCustomQuery';
import getTCAPUsers from 'API/TCAPUser/getTCAPUsers';

/** (3131) The company's users and how many of them have a number assigned. */
const useGetCompanyUsers = (companyId, options = {}) =>
    useQuery({
        queryKey: ['setupProgress', 'users', companyId],
        queryFn: () => getTCAPUsers(companyId),
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetCompanyUsers;
